// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"741":"55c1d8ae","891":"b25b1fe9"}[chunkId] + ".css";
};